import { Grid, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { Link } from "react-router-dom";

interface AuthLayoutProps {
  children: React.ReactNode;
  title: string;
  description: string;
}

export default function AuthLayout({ children, title, description }: AuthLayoutProps) {
  return (
    <>
      <Box
        sx={{
          background: 'radial-gradient(circle, rgba(10, 43, 91, 0.9863542829241071) 0%, rgba(8, 34, 69, 1) 46%, rgba(6, 24, 46, 1) 82%)',
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          width: "100%",
          height: "100%",
          position: "absolute",
          zIndex: -1,
        }}
      />
      <Box sx={{ height: "100vh", display: "flex", maxWidth: "500px", margin: "0 auto" }}>
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
          sx={{ margin: "0 1rem" }}
        >
          <Link to="/login">
            <img src={require("../../assets/brand.svg").default} alt="logo" style={{ width: "150px", userSelect: "none" }} />
          </Link>

          <Typography variant="h5" component="h1" color="white" sx={{ mt: "1rem" }}>{title}</Typography>
          <Typography variant="body1" color="#8392a5" sx={{ mb: "1rem" }}>{description}</Typography>

          {children}
        </Grid>
      </Box>

    </>
  )
}